import { slugify } from './../../../utils/utils';
import BaseTypesenseSearch from '../typesense-search';

import {
  getRessourceHitsWidgets,
  getRessourceRefinements,
  getRessourceCurrentRefinements,
  getRessourceClearRefinements,
  getRessourceStats,
  getRessourcePagination,
} from './ressource-widgets';
import { Widget } from 'instantsearch.js';
import { configure } from 'instantsearch.js/es/widgets';

interface IThematic {
  slug: string;
  name: string;
  color: string;
  color_hover: string;
  color_text: string;
}

export default class Ressource extends BaseTypesenseSearch {
  private resultHitsContainer: HTMLDivElement | null = null;
  private refinementsContainerThematics: HTMLDivElement | null = null;
  private refinementsContainerFormats: HTMLDivElement | null = null;
  private refinementsContainerTypologies: HTMLDivElement | null = null;
  private refinementsContainerCategories: HTMLDivElement | null = null;
  private currentRefinementsContainer: HTMLDivElement | null = null;
  private clearRefinementsContainer: HTMLDivElement | null = null;
  private statsContainer: HTMLDivElement | null = null;
  private paginationContainer: HTMLDivElement | null = null;
  private metaThematic: IThematic[] = [];

  constructor() {
    super();
  }

  getWidgets() {
    return [
      this.resultHitsContainer ? getRessourceHitsWidgets(this.resultHitsContainer) : null,
      this.refinementsContainerThematics ? getRessourceRefinements(this.refinementsContainerThematics, 'thematics', this.refinementsThematicTemplateRenderer.bind(this)) : null,
      this.refinementsContainerFormats ? getRessourceRefinements(this.refinementsContainerFormats, 'formats', this.refinementstemplateRenderer.bind(this)) : null,
      this.refinementsContainerTypologies ? getRessourceRefinements(this.refinementsContainerTypologies, 'typologies', this.refinementstemplateRenderer.bind(this)) : null,
      this.refinementsContainerCategories ? getRessourceRefinements(this.refinementsContainerCategories, 'categories', this.refinementstemplateRenderer.bind(this)) : null,
      this.currentRefinementsContainer ? getRessourceCurrentRefinements(this.currentRefinementsContainer) : null,
      this.clearRefinementsContainer ? getRessourceClearRefinements(this.clearRefinementsContainer) : null,
      this.configureParams ? configure(this.configureParams) : null,
      this.statsContainer ? getRessourceStats(this.statsContainer) : null,
      this.paginationContainer ? getRessourcePagination(this.paginationContainer) : null,
    ].filter(Boolean) as Widget[];
  }

  refinementsThematicTemplateRenderer({ label, value, count, isRefined }: {
    label: string;
    value: string;
    count: number;
    isRefined: boolean
  }) {
    const slug = slugify(value);
    const meta = this.metaThematic?.find(meta => meta.name === label);
    const style = meta ? `
      style="--color: ${meta.color};--color_hover:${meta.color_hover};--color-text:${meta.color_text}"
    ` : '';
    return `
      <label data-index-name="${this.indexName}" class="ais-RefinementList-label ${isRefined ? 'refined' : ''}" ${style}  for="ais-Refinement-${slug}">
        <input id="ais-Refinement-${slug}" class="ais-RefinementList-checkbox" type="checkbox" value="${value}" ${isRefined ? 'checked' : ''} aria-checked="${isRefined}"/>
        <span class="ais-RefinementList-labelText">${label}</span>
        <span class="ais-RefinementList-count">${count}</span>
      </label>
    `;
  }

  refinementstemplateRenderer({ label, value, count, isRefined }: {
    label: string;
    value: string;
    count: number;
    isRefined: boolean
  }) {
    const slug = slugify(value);
    return `
      <label class="ais-RefinementList-label" for="ais-Refinement-${slug}">
        <input id="ais-Refinement-${slug}" class="ais-RefinementList-checkbox" type="checkbox" value="${value}" ${isRefined ? 'checked' : ''} aria-checked="${isRefined}" />
        <span class="ais-RefinementList-labelText">${label}</span>
        <span class="ais-RefinementList-count">${count}</span>
      </label>
    `;
  }

  init() {
    const { thematicContainer, metaThematic, categoryContainer } = this.dataset;
    this.resultHitsContainer = this.querySelector('.result-hits');
    this.refinementsContainerThematics = this.querySelector('.refinements-thematics');
    this.refinementsContainerFormats = this.querySelector('.refinements-formats');
    this.refinementsContainerTypologies = this.querySelector('.refinements-typologies');
    this.refinementsContainerCategories = this.querySelector('.refinements-categories');
    this.currentRefinementsContainer = this.querySelector('.current-refinements');
    this.clearRefinementsContainer = this.querySelector('.clear-refinements');
    this.statsContainer = this.querySelector('.search-stats');
    this.paginationContainer = this.querySelector('.search-pagination');

    if (thematicContainer) {
      this.refinementsContainerThematics = document.querySelector(thematicContainer);
    }

    if (categoryContainer) {
      this.refinementsContainerCategories = document.querySelector(categoryContainer);
    }

    if (metaThematic) {
      try {
        this.metaThematic = JSON.parse(metaThematic);
        // console.log('this.metaThematic:: ', this.metaThematic);
      } catch (e: unknown) { console.error(e); }
    }

    this.searchInstance?.start();
    this.searchInstance?.addWidgets(this.getWidgets());
  }

  connectedCallback() {
    setTimeout(() => {
      super.initSearchInstance();
      this.init();
    });
  }
}
